module.exports = __webpack_public_path__ + "static/fonts/Oswald-LightItalic.17008ca.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-LightItalic.ttf
// module id = PJUf
// module chunks = 1